module.exports = __webpack_public_path__ + "static/media/grey-s-20.8234c8f9.png";